var exports = {
  "k": "xfd349460--cc18c4--container",
  "w": "xfd349460--cc18c4--logo",
};

module.exports = exports;
